export const MENU_URL = process.env.REACT_APP_HOST;
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL;
export const ICONS_URL = process.env.REACT_APP_ICONS_URL;

export const LANG = "lang";
export const TUTORIAL = "tutorial";
export const CONFIG_LAST_UPDATED = "configLastUpdated";

export const DEFAULT_LANG = +process.env.REACT_APP_DEFAULT_LANG;

export const TIME_ZONE = "America/Mexico_City";

export const daysTranslations = {
  SUNDAY: {
    en: 'Sunday',
    es: 'Domingo'
  },
  MONDAY: {
    en: 'Monday',
    es: 'Lunes'
  },
  TUESDAY: {
    en: 'Tuesday',
    es: 'Martes'
  },
  WEDNESDAY: {
    en: 'Wednesday',
    es: 'Miercoles'
  },
  THURSDAY: {
    en: 'Thurday',
    es: 'Jueves'
  },
  FRIDAY: {
    en: 'Friday',
    es: 'Viernes'
  },
  SATURDAY: {
    en: 'Saturday',
    es: 'Sabado'
  }
}

export const DAYS_OF_WEEK = Object.keys(daysTranslations);